import React, { ComponentProps } from "react";

export default function ChevronRightIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="10"
      viewBox="0 0 6 10"
      fill="none"
      {...props}
    >
      <path
        d="M3.53979 4.97917L0.311666 1.75083C0.103889 1.54319 0 1.30333 0 1.03125C0 0.759167 0.103889 0.519306 0.311666 0.311667C0.519305 0.103889 0.759167 0 1.03125 0C1.30333 0 1.54556 0.10618 1.75792 0.318541L5.6975 4.25813C5.79042 4.35674 5.8641 4.46938 5.91854 4.59604C5.97285 4.72285 6 4.85194 6 4.98333C6 5.11472 5.97285 5.24382 5.91854 5.37063C5.8641 5.49729 5.79042 5.60715 5.6975 5.70021L1.75792 9.63979C1.54556 9.85215 1.30681 9.95486 1.04167 9.94792C0.776528 9.94097 0.540139 9.83361 0.3325 9.62583C0.124722 9.41819 0.0208333 9.17833 0.0208333 8.90625C0.0208333 8.63417 0.124722 8.39431 0.3325 8.18667L3.53979 4.97917Z"
        fill={props.fill || "white"}
      />
    </svg>
  );
}
